import { sfetchJson } from '../internals/sfetch';

import type { ApiConf, BatchDeletionResponse } from '../types/common.types';

export const getBatchDeleteOptions = (token: string, IDs: string[]): RequestInit => ({
  credentials: 'include',
  headers: {
    Authorization: `bearer ${token}`,
    'Content-Type': 'application/json',
  },
  method: 'DELETE',
  body: JSON.stringify(IDs),
});

export const batchDelete = async (args: {
  apiConf: ApiConf;
  IDs: string[];
  entityType: 'pipes' | 'systems';
}): Promise<BatchDeletionResponse> => {
  const { apiConf, IDs, entityType } = args;
  const { subUrl, token } = apiConf;

  const options: RequestInit = getBatchDeleteOptions(token, IDs);

  const url = `${subUrl}/${entityType}`;

  return await sfetchJson(url, options);
};
